import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISiteSAMLAttributeMapping } from '../types/ISiteSAMLConfiguration';

export interface ISetSiteAttributeMappingRequest {
  siteSAMLAttributeMapping: ISiteSAMLAttributeMapping;
  idpConfigurationId: string;
  idpConfigurationName: string;
}
export class SetSiteAttributeMappingRequest extends Request<ISetSiteAttributeMappingRequest, IResult> {
  constructor(mapping: ISetSiteAttributeMappingRequest) {
    super('setSiteAttributeMapping', mapping);
  }
}
